import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert
} from '@mui/material';
import { apiClient } from '../../lib/apiClient';

function ChurchMembers({ user }) {
  const [church, setChurch] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const myChurches = await apiClient.getMyChurches(user.id);
        if (myChurches.length === 0) {
          setError('You are not assigned to any church');
          return;
        }

        const currentChurch = myChurches[0];
        setChurch(currentChurch);

        // Get all users and filter those who are members of this church
        const allUsers = await apiClient.getAllUsers();
        const churchMembers = allUsers.filter(u => u.churchIds?.includes(currentChurch.id));
        setMembers(churchMembers);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchData();
    }
  }, [user]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.75rem', sm: '2.125rem' } }}>
        Church Members
      </Typography>
      {church && (
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2, fontSize: { xs: '0.875rem', sm: '1rem' } }}>
          {church.name}
        </Typography>
      )}
      <Box sx={{ overflowX: 'auto', mt: 3 }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', fontSize: { xs: '0.875rem', sm: '1rem' } }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', display: { xs: 'none', md: 'table-cell' } }}>Phone Number</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Role</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members.map((member) => (
                <TableRow key={member.id}>
                  <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>{member.name}</TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{member.phoneNumber}</TableCell>
                  <TableCell>{member.role?.replace('_', ' ') || 'N/A'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default ChurchMembers;

